import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { useCourse } from '../hooks/useCourse';
import { MindmapData } from '../types';

export function MindMap() {
  const { courseId } = useParams<{ courseId: string }>();
  const { course, isLoading } = useCourse(courseId || '');
  const [selectedMindmap, setSelectedMindmap] = useState<MindmapData | null>(null);

  if (isLoading || !course) {
    return <div className="loading">Laden...</div>;
  }

  // Show selected mindmap detail view
  if (selectedMindmap) {
    return (
      <div className="mindmap-view">
        <button className="back-link" onClick={() => setSelectedMindmap(null)}>
          <ArrowLeft size={18} />
          Zurück zur Auswahl
        </button>

        <h1>
          {selectedMindmap.icon} {selectedMindmap.title}
        </h1>

        <div className="mindmap-cards">
          {selectedMindmap.cards.map((card, index) => (
            <div
              key={index}
              className={`mindmap-card card-${card.color}`}
            >
              <h3>{card.title}</h3>
              <ul>
                {card.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Show mindmap selection cards
  return (
    <div className="mindmap-view">
      <Link to={`/course/${courseId}`} className="back-link">
        <ArrowLeft size={18} />
        Zurück
      </Link>

      <h1>Mindmaps</h1>
      <p className="mindmap-subtitle">Wähle eine Mindmap zum Anzeigen:</p>

      <div className="mindmap-selection">
        {course.mindmaps.map((mindmap) => (
          <button
            key={mindmap.id}
            className="mindmap-select-card"
            onClick={() => setSelectedMindmap(mindmap)}
          >
            <span className="mindmap-select-icon">{mindmap.icon}</span>
            <div className="mindmap-select-info">
              <h3>{mindmap.title}</h3>
              <p>{mindmap.cards.length} Karten</p>
            </div>
            <ChevronRight size={20} className="mindmap-select-arrow" />
          </button>
        ))}
      </div>
    </div>
  );
}
